"use client";

import useClipboard from "@/hooks/useClipboard";
import { constructPostLink } from "@/lib/utils";
import { TCommunityFeedPost } from "@/types/post";
import { Share2Icon } from "lucide-react";

const FeedPostShareButton = ({
	post,
}: {
	post: Pick<TCommunityFeedPost, "community" | "channel" | "slug" | "title">;
}) => {
	const { isCopied, handleCopy } = useClipboard();

	const handleShare = () => {
		const url = constructPostLink({
			communitySlug: post.community?.slug || "",
			channelSlug: post.channel?.slug,
			postSlug: post.slug,
		});

		const isMacOS = /Macintosh|Mac OS X/.test(navigator.userAgent);

		if (!isMacOS && navigator.share) {
			navigator
				.share({
					title: post.title,
					url,
				})
				.then(() => {
					console.log("Thanks for sharing!");
				})
				.catch(console.error);
		} else {
			handleCopy(url);
		}
	};

	return (
		<button
			type="button"
			onClick={handleShare}
			className="relative flex w-full items-center justify-center gap-1 rounded-lg border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-600"
		>
			<span>
				<Share2Icon className="h-4 w-4" />
			</span>

			<span>Share</span>

			{isCopied ? (
				<div className="absolute -top-5 left-1/2 translate-x-[-50%] rounded-lg border border-brand-primary bg-brand-primary px-3 py-1 text-xs font-medium text-white">
					Link Copied
				</div>
			) : null}
		</button>
	);
};

export default FeedPostShareButton;
